const BASE = "https://www.printlivros.com.br";

export const WHATSAPP_NUMBER = "5519997967645";
export const waLink = (text) => `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const LINKS = {
  home: `${BASE}/index.html`,
  quemSomos: `${BASE}/menu/quem-somos/index.html`,
  contato: `${BASE}/menu/contato/index.html`,
  login: `${BASE}/index.html#login`,
  orcamento: `${BASE}/?step=1#modelo-pick`,
  portfolio: "https://www.instagram.com/printlivros/",
  maps: "https://g.page/r/CWudgF_hM2mCEBM/review",
  privacidade: `${BASE}/menu/footer/politica-de-privacidade/index.html`,
};

export const CONTACT = {
  address: "R. dos Evangélicos, 81 — Jardim Santo André, Hortolândia/SP",
  phone1: "(19) 3504-6333",
  phone2: "(19) 9 9796-7645",
  email: "atendimento@printlivros.com.br",
  hours: "Segunda a sexta · 08:00 às 18:00",
};

export const SERVICE_GROUPS = [
  {
    title: "Livros Sob Demanda",
    links: [
      { label: "Livros a partir de 1 unidade", url: `${BASE}/menu/servicos/livros-sob-demanda/impressao-de-livros-1-unidade/index.html` },
      { label: "Livros capa dura", url: `${BASE}/menu/servicos/livros-sob-demanda/impressao-de-livros-capa-dura/index.html` },
      { label: "Livros brochura", url: `${BASE}/menu/servicos/livros-sob-demanda/impressao-de-livros-brochura/index.html` },
      { label: "Pequenas tiragens", url: `${BASE}/menu/servicos/livros-sob-demanda/impressao-de-pequenas-tiragens/index.html` },
      { label: "Autores independentes", url: `${BASE}/menu/servicos/livros-sob-demanda/grafica-para-autores-independentes/index.html` },
    ],
  },
  {
    title: "Colorir e Infantis",
    links: [
      { label: "Livros para colorir", url: `${BASE}/menu/servicos/livros-infantis/impressao-de-livros-para-colorir/index.html` },
      { label: "Colorir infantil", url: `${BASE}/menu/servicos/livros-infantis/impressao-de-livros-para-colorir-infantil/index.html` },
      { label: "Atividades educativas", url: `${BASE}/menu/servicos/livros-infantis/impressao-de-livros-de-atividades-educativas/index.html` },
      { label: "Infantis personalizados", url: `${BASE}/menu/servicos/livros-infantis/impressao-de-livros-infantis-personalizados/index.html` },
      { label: "Cadernos de desenho", url: `${BASE}/menu/servicos/livros-infantis/impressao-de-cadernos-de-desenho/index.html` },
      { label: "Livros pedagógicos", url: `${BASE}/menu/servicos/livros-infantis/impressao-de-livros-pedagogicos/index.html` },
    ],
  },
  {
    title: "Serviços Editoriais",
    links: [
      { label: "Registro de ISBN", url: `${BASE}/menu/servicos/servicos-editoriais/registro-de-isbn/index.html` },
      { label: "Criação de capa", url: `${BASE}/menu/servicos/servicos-editoriais/criacao-de-capa-de-livro/index.html` },
      { label: "Diagramação", url: `${BASE}/menu/servicos/servicos-editoriais/diagramacao-de-livros/index.html` },
      { label: "Revisão ortográfica", url: `${BASE}/menu/servicos/servicos-editoriais/revisao-ortografica/index.html` },
      { label: "Preparação de arquivo", url: `${BASE}/menu/servicos/servicos-editoriais/preparacao-de-arquivo/index.html` },
    ],
  },
  {
    title: "Apostilas",
    links: [
      { label: "Impressão de apostilas", url: `${BASE}/menu/servicos/apostilas/impressao-de-apostilas/index.html` },
      { label: "Apostilas personalizadas", url: `${BASE}/menu/servicos/apostilas/impressao-de-apostilas-personalizadas/index.html` },
      { label: "Materiais didáticos", url: `${BASE}/menu/servicos/apostilas/impressao-de-materiais-didaticos/index.html` },
      { label: "Cursos e treinamentos", url: `${BASE}/menu/servicos/apostilas/impressao-de-cursos-e-treinamentos/index.html` },
      { label: "Manuais e guias", url: `${BASE}/menu/servicos/apostilas/impressao-de-manuais-e-guias/index.html` },
      { label: "Ebooks físicos", url: `${BASE}/menu/servicos/apostilas/impressao-de-ebooks-fisicos/index.html` },
    ],
  },
  {
    title: "Outros Impressos",
    links: [
      { label: "Catálogos", url: `${BASE}/menu/servicos/outros-impressos/impressao-de-catalogos/index.html` },
      { label: "Revistas", url: `${BASE}/menu/servicos/outros-impressos/impressao-de-revistas/index.html` },
      { label: "Agendas personalizadas", url: `${BASE}/menu/servicos/outros-impressos/impressao-de-agendas-personalizadas/index.html` },
      { label: "Livretos", url: `${BASE}/menu/servicos/outros-impressos/impressao-de-livretos/index.html` },
      { label: "Materiais promocionais", url: `${BASE}/menu/servicos/outros-impressos/impressao-de-materiais-promocionais/index.html` },
    ],
  },
];
